import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Observable, Subject } from 'rxjs';
import { ICredentials } from '../models/credentials.model';
import { ImpersonateService } from 'app/profile/impersonate-user/impersonate.service';

const routes = {
  user_context: () => `/v1/user-management/context`
};

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  credentials!: ICredentials | undefined;

  private destroy$ = new Subject<void>();
  private role!: string;

  constructor(private http: HttpClient, private msalService: MsalService, private impersonateService: ImpersonateService) { }

  setUserRole(role: string) {
    this.role = role;
  }

  get userRole(): string {
    return this.role;
  }

  getUserContext(): Observable<any> {
    return this.http.get(routes.user_context(), {});
  }

  setCredentials(credentials?: ICredentials | undefined) {
    this.credentials = credentials;
    credentials ? localStorage.setItem('credentials', JSON.stringify(credentials)) : localStorage.removeItem('credentials');

    if(credentials) {
      this.setUserRole(credentials.role);
    }
  }

  getCredentialsFromStorage(): ICredentials | undefined {
    const credentials = localStorage.getItem('credentials');
    return credentials ? JSON.parse(credentials!) : undefined;
  }

  getCredentials(): ICredentials | undefined {
    const impersonatedUserCredentials: ICredentials | undefined = this.impersonateService.getImpersonatedUserCredentials();
    return impersonatedUserCredentials ? impersonatedUserCredentials : this.credentials;
  }

  logout() {
    this.setCredentials();
    localStorage.clear();
    sessionStorage.clear();
    this.msalService.logoutRedirect();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
